import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@famly/mf_layout_box';
/**
 * Renders a whitelabel logo from a URL.
 * Returns null when no URL is configured.
 *
 * @param props.url - Logo image URL, or null if no asset is configured
 */
export const WhitelabelLogo = ({ url, height = '100px' }) => {
    if (url === null) {
        return null;
    }
    // The height sits on a wrapper because a responsive value can't go on the img's own height attribute
    return (_jsx(Box, { minHeight: height, height: height, width: "100%", maxWidth: "250px", children: _jsx(Box, { component: "img", alt: "", display: "block", minHeight: "100%", height: "100%", width: "100%", src: url }) }));
};
